import { Box, Flex } from '@modusign/design-system';
import { useDispatch } from 'react-redux';

import Breakpoint from '@app/components/Breakpoint';
import DocumentHeaderDivider from '@app/components/DocumentHeaderDivider';
import DocumentZoomButton from '@app/components/DocumentZoomButton';
import Header from '@app/components/Header';
import HelpButton from '@app/components/HelpButton';
import StepProgressBar from '@app/components/StepProgressBar';
import * as BREAKPOINT from '@app/constants/breakpoint';
import { zoomIn, zoomOut } from '@app/libs/reactPdfJs/store/actions';

import ContractLinkCreateStep from '../../types/ContractLinkCreateStep';

interface ContractLinkCreateHeaderProps {
  step: ContractLinkCreateStep;
}

const contractLinkCreateSteps: Array<{
  step: ContractLinkCreateStep;
  title: string;
}> = [
  { step: 'fieldSetup', title: '입력설정' },
  { step: 'etcSetup', title: '기타설정' },
];

function ContractLinkCreateHeader({ step }: ContractLinkCreateHeaderProps) {
  const dispatch = useDispatch();

  function handleZoomInClick() {
    dispatch(zoomIn());
  }

  function handleZoomOutClick() {
    dispatch(zoomOut());
  }

  return (
    <Header>
      <Flex flex={[0, null, 1]} />
      <Flex alignItems="center" flex="1" justifyContent={[null, null, 'center']} px="16px">
        <StepProgressBar
          currentStepIndex={
            contractLinkCreateSteps.findIndex((stepItem) => stepItem.step === step) + 1
          }
          steps={contractLinkCreateSteps.map((stepItem) => stepItem.title)}
        />
      </Flex>
      <Flex alignContent="center" flex="1" justifyContent="flex-end" pr={[0, 4]}>
        {step === 'fieldSetup' && (
          <>
            <DocumentHeaderDivider />
            <Box display="inline-block" my="auto">
              <DocumentZoomButton onZoomIn={handleZoomInClick} onZoomOut={handleZoomOutClick} />
            </Box>
          </>
        )}
        <Breakpoint compare={(innerWidth) => innerWidth > BREAKPOINT.MOBILE}>
          <DocumentHeaderDivider />
          <Box display="inline-block" my="auto">
            <HelpButton variant="darkIcon" />
          </Box>
        </Breakpoint>
      </Flex>
    </Header>
  );
}

export default ContractLinkCreateHeader;
